import Configure from './configure';
import SecondNic from './second_network_interface';

const RemoteAccess = [
    Configure,
    SecondNic,
];

export default RemoteAccess;